import { RootState } from "store/store";


class Sse {
  static readonly estado = (it: RootState) => it.notificacoes.sse.estado;
}


class Lista {
  static readonly estado = (it: RootState) => it.notificacoes.lista.estado;
  static readonly erros = (it: RootState) => it.notificacoes.lista.erros;
  
  static readonly notificacoes = (it: RootState) => it.notificacoes.lista.elementos;
  static readonly totalNaoLidas = (it: RootState) => it.notificacoes.lista.totalNaoLidas;
  /**
   * @returns Última notificação a exibir. Caso não tenha nenhuma a exibir, corresponde a última notificação exibida.
   */
  static readonly notificacaoAExibir = (it: RootState) => it.notificacoes.notificacaoAExibir;
}


export class NotificacoesSelector {
  static readonly sse = Sse;
  static readonly lista = Lista;
}
